export default __webpack_public_path__ + "static/media/illustration.4675912f.svg";